"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = process.env.NODE_ENV === "production" ? {
  name: "3lhzq",
  styles: "input[type='number']{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;}input[type='number']::-webkit-inner-spin-button,input[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;}"
} : {
  name: "13uyymu-base",
  styles: "input[type='number']{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;}input[type='number']::-webkit-inner-spin-button,input[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;};label:base;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var controls = function controls(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;justify-content:center;padding-right:", theme.spacing[7], ";margin:0 -", theme.spacing[3], ";button{width:", theme.spacing[6], ";height:", theme.spacing[6], ";line-height:0;color:", theme.color.monochrome.mediumDark, ";&:hover{color:", theme.color.monochrome.black, ";}}svg{width:100%;height:100%;}&>button:first-of-type svg{transform:rotate(180deg);}" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
};

var maxHint = function maxHint(theme) {
  return /*#__PURE__*/(0, _react.css)("margin-left:-", theme.spacing[7], ";white-space:nowrap;font-size:", theme.fontSize.large, ";line-height:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:maxHint;"));
};

var styles = {
  base: base,
  controls: controls,
  maxHint: maxHint
};
exports.styles = styles;
//# sourceMappingURL=NumberField.styles.js.map